export const PrintAction = ({ onPrint, disabled }) => ({
  label: "Print",
  icon: "print",
  iconStyle: "solid",
  onClickBulk: onPrint,
  disabled,
})
